import { Fragment } from "react";

const DOW_LABELS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const DOW_FULL = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

function formatHour(hour) {
  const period = hour >= 12 ? "PM" : "AM";
  const h12 = hour % 12 === 0 ? 12 : hour % 12;
  return `${h12} ${period}`;
}

export const ListeningHeatmapWidget = ({ data, loading }) => {
  const heatmap = data?.heatmap || [];
  const grid = {};
  let max = 1;
  let peak = null;
  heatmap.forEach((h) => {
    grid[`${h.dow}-${h.hour}`] = h.count;
    if (h.count > max) max = h.count;
    if (!peak || h.count > peak.count) peak = h;
  });

  const colorFor = (count) => {
    if (!count) return "rgba(255,255,255,0.04)";
    const intensity = Math.min(1, count / max);
    if (intensity < 0.34) return "rgba(37,99,235,0.35)";
    if (intensity < 0.67) return "rgba(16,185,129,0.55)";
    return "rgba(245,158,11,0.85)";
  };

  return (
    <div data-testid="listening-heatmap-widget" className="bg-slate-900/80 border border-slate-800 rounded-xl p-5 shadow-lg backdrop-blur-md min-w-0">
      <h3 className="text-lg font-semibold text-slate-200 mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Listening Heatmap</h3>
      {loading ? (
        <p className="text-sm text-slate-500">Loading…</p>
      ) : heatmap.length === 0 ? (
        <p className="text-sm text-slate-500">No play activity recorded yet.</p>
      ) : (
        <>
          {peak && (
            <div
              data-testid="peak-listening-hour-callout"
              className="mb-4 flex items-center gap-3 rounded-lg border border-amber-500/30 bg-amber-500/10 px-4 py-2.5"
            >
              <span className="w-2 h-2 rounded-full bg-amber-400 shrink-0" />
              <p className="text-sm text-amber-200">
                Peak listening time: <span className="font-semibold text-amber-100">{DOW_FULL[peak.dow - 1]}s around {formatHour(peak.hour)}</span>
                <span className="text-amber-300/70 font-mono text-xs ml-2">({peak.count} plays)</span>
              </p>
            </div>
          )}
          <div className="overflow-x-auto">
            <div className="inline-grid" style={{ gridTemplateColumns: "40px repeat(24, 1fr)", gap: "2px" }}>
              <div />
              {Array.from({ length: 24 }).map((_, h) => (
                <div key={h} className="text-[9px] text-slate-500 text-center font-mono">{h}</div>
              ))}
              {DOW_LABELS.map((label, dowIdx) => {
                const dow = dowIdx + 1;
                return (
                  <Fragment key={dow}>
                    <div className="text-[10px] text-slate-500 font-mono flex items-center">{label}</div>
                    {Array.from({ length: 24 }).map((_, hour) => {
                      const count = grid[`${dow}-${hour}`] || 0;
                      return (
                        <div
                          key={`${dow}-${hour}`}
                          title={`${label} ${hour}:00 — ${count} plays`}
                          className="w-3.5 h-3.5 rounded-sm"
                          style={{ backgroundColor: colorFor(count) }}
                        />
                      );
                    })}
                  </Fragment>
                );
              })}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
